import useReduceStore from 'hooks/ReduceStoreHook';
import ProductStore from 'stores/ProductStore';
import HttpService from 'service/HttpService';

import ProductAPI from 'service/api/ProductAPI';

export const useFeaturedProducts = () => {
    const featuredProducts = useReduceStore(ProductStore, (store) => store.getFeaturedProducts(), 
                                        () => ProductAPI.getFeaturedProducts(), []);
                                        
    return featuredProducts;
};


export const usePopularProducts = () => {
    const featuredProducts = useReduceStore(ProductStore, (store) => store.getPopularProducts(), 
                                        () => ProductAPI.getPopularProducts(), []);
                                        
    return featuredProducts;
};

//userId can be null, when getting for current session, hence adding if userid avaiilable check
export const useDesignerProducts = (userId) => {
    const userProducts = useReduceStore(ProductStore, (store) => userId? store.getProducts(userId): null, 
                                () => {
                                    if(userId)
                                        HttpService.getProducts(userId)
                                }, [userId]);
      
    //TODO: use per product type later
    // ProductAPI.getUserProductsPerType(userId);
    return userProducts;
}



export const useProduct = (productId) => {
    const product = useReduceStore(ProductStore, (store) => store.getProduct(productId), 
                                () => HttpService.getProduct(productId), [productId]);
                                
    return product;
}





// WEBPACK FOOTER //
// ./src/hooks/ProductHook.js